import { Image } from "@wdpr/groot-components";
const componentName = "branding-character";

const BrandingCharacter = ({ cdnAssetsUrl, url = `${cdnAssetsUrl}/images/header/fairy.png` }) => (
	<div className={`syndicated-${componentName}`}>
		<Image
			name={componentName}
			image={{
				url,
				title: componentName,
			}}
		/>
	</div>
);

export default BrandingCharacter;
